<!-- Acrescentado   -->
<div class="w-full px-[50px] mx-auto flex justify-between items-center h-20">
  
  <!-- Left section - Breadcrumb -->
  <div class="flex items-center text-gray-500 sm-hidden">
    <app-breadcrumb></app-breadcrumb>
  </div>

  <ng-container *ngIf="isAuthenticated; else loginButton">
    <!-- Center section -->
    <div class="flex-1 flex justify-center">
      <app-select-system
        [placeholder]="'header.selectClient' | translate"
        [opcoes]="opcoesCliente"
        [valorSelecionado]="clienteSelecionado"
        [icone]="'domain'"
        (valorSelecionadoChange)="onClienteSelecionadoChange($event)">
      </app-select-system>
    </div>

    <!-- Right section -->
    <div class="flex items-center gap-4">
      @if (notificationToken) {
        <dm-notification-center-sdk
          [attr.url]="notificationApiUrl"
          [attr.token]="notificationToken"
          application="DMAnalytics"
          systemColor="#FF7E24"
          [attr.locale]="locale"
          size="24">
        </dm-notification-center-sdk>
      }
      <user-details (logoutClicked)="logout()" />
    </div>
  </ng-container>

  <ng-template #loginButton>
    <div class="flex-1 flex justify-end">
      <app-generic-button text="Login" type="confirm" (click)="login()"></app-generic-button>
    </div>
  </ng-template>

</div>
